const index = [

    { min: 0, index: 0 },
    { min: 60, index: 1 },
    { min: 80, index: 2 },
    { min: 100, index: 3 },
    { min: 120, index: 4 },
    { min: 160, index: 5 },
    { min: 240, index: 6 },

]

export function getSnsIndexFromAmount(amount: number): number {

    var match = index.find(i => i.min > amount)

    if (match) {
        return (match.index ? match.index - 1 : 0)
    }

}
